import React from 'react';
import styled from 'styled-components';
import { style } from '../../api';

import { Heart } from './Icons';
import { TextRegular12 } from './Text';
import { useIsDesktop } from '../../style/constants';

export default styled(
  ({
    likes,
    className,
    color = style.grey_main_new,
  }: {
    likes: number;
    className?: string;
    color?: string;
  }) => {
    const isDesktop = useIsDesktop();
    return (
      <Wrapper className={className} color={color}>
        <Heart color={color} size={isDesktop ? 14 : 12} />
        {likes}
      </Wrapper>
    );
  },
)``;

const Wrapper = styled(TextRegular12)<{ color: string }>`
  display: flex;
  align-items: center;
  height: 16px;
  color: ${(p) => p.color};
  svg {
    margin-left: -3px;
    margin-right: 3px;
  }
`;
